import { useTranslation } from "react-i18next";
import PageTitle from "../../components/common/PageTitle/PageTitle";
import ServiceModulesContainer from "./ServiceModulesContainer";

const breadcrumbs = [
  {
    title: "serviceModulesPage.serviceModules",
    link: "serviceModules",
  },
];

const ServiceModulesPage = () => {
  const { t } = useTranslation()

  return (
    <>
      <PageTitle
        breadcrumbs={breadcrumbs}
        title={t("serviceModulesPage.serviceModules")}
      />
      <ServiceModulesContainer />
    </>
  );
};

export default ServiceModulesPage;